import req from "../../../services/psikotest/request";

class Company {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/company/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async get(id: string) {
    try {
      const res = await req.get("/api/psikotest_system/company/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async save(data: TPSCompany) {
    try {
      const res = await req.put("/api/psikotest_system/company/" + data.id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(data: TPSCompany) {
    try {
      const res = await req.delete("/api/psikotest_system/company/", { data });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default Company;
